import { useState } from 'react';

function usePageOption(size = 50) {
  const [pageOption, setPageOption] = useState({ page: 1, size });

  return {
    pageOption,
    handlePage: setPageOption,
  };
}

export default usePageOption;
